module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/gotop-13b8d043eec32b7512175a87c6338ecf.svg&quot;;"